import React, { Component } from 'react';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import replace from 'lodash/replace';
import {deepClone} from './../../../utils/copyObject';
import { validateEmail } from './../../../utils/validations';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody,Row,Col} from 'reactstrap';
import Select from 'react-select';
import officeCreatedIcon from './../../../assets/office_created_icon.svg';
import InviteAdminModal from './InviteAdminModal';
import InvitedAdminModal from './InvitedAdminModal';

class InviteAdmin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      initialInputCount : 3,
      invitationOffice : null,
      showInvitationModal : false,
      showInvitedAdminModal : false,
      selectedOffice : {},
      users : []
    }
  }

  handleInputChange = (id,{name,value}) => {
    const {users} = this.state;
    const cloneUsers = deepClone(users);
    let index = findIndex(cloneUsers,{id : id});
    if(index > -1) {
      cloneUsers[index][name] = value;
    } else {
      cloneUsers.push({id : id,[name]:value});
    }
    this.setState({users : cloneUsers});
  }

  handleAddMember = () => {
    this.setState((prevState) => ({initialInputCount : prevState.initialInputCount + 1}));
  }

  toggle = () => {
    this.setState((prevState) => ({showInvitationModal : !prevState.showInvitationModal, 
      modalError : false, errorMessage : '',users : []}));
  }

  handleInviteClick = (selectedOffice) => {
    this.setState({showInvitationModal : true,selectedOffice : selectedOffice});
  }

  handleInviteComplete = () => {
    const {users,selectedOffice} = this.state;


    console.log('users---', users)

    // return
    const invalidEmails = users.filter((user) => {
      console.log('user---', user)

      if(!user.email || !validateEmail(user.email)) {
        return true;
      }
      return false;

      
    });
    // if()

    // return

    if(invalidEmails.length > 0 || users.length === 0) {
      this.setState({
        modalError : true,
        errorMessage : 'Please enter valid email address.'
      })
    } else {
      this.props.onAdminInvited(users,selectedOffice);
      this.setState({showInvitationModal:false,modalError : false, errorMessage : ''});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.allOfficesWithInvitations.length > 0) {
      const {allOfficesWithInvitations} = nextProps;
      const {selectedOffice} = this.state;
      // if(selectedOffice) {
      // console.log(nextProps.allOfficesWithInvitations);
      const office = find(allOfficesWithInvitations,{officePath : selectedOffice.officePath});
      if(office) {
        this.setState({
          selectedOffice : office
        });
      }
      // }
    }
  }

  toggleInvitedAdminModal = (office) => {this.setState((p) => ({showInvitedAdminModal : !p.showInvitedAdminModal, selectedOffice : office}))}

  applySearchSort = () => {
    const {searchedTerm,allOfficesWithInvitations,sortType} = this.props;
    let returnList = allOfficesWithInvitations;
    // console.log(sortType);
    if(sortType === 'a-z') {
      returnList = sortBy(allOfficesWithInvitations,(office) => office.officeName);
    } else if(sortType === 'z-a') {
      returnList = reverse(sortBy(allOfficesWithInvitations,(office) => office.officeName));
    } else if(sortType === 'invites-descending' 
      && filter(allOfficesWithInvitations,(office) => office.invitedUsers.length > 0).length > 0) {
      returnList = reverse(sortBy(allOfficesWithInvitations,(office) => office.invitedUsers.length));
    } else if(sortType === 'invites-ascending' &&
      filter(allOfficesWithInvitations,(office) => office.invitedUsers.length > 0).length > 0) {
      returnList = sortBy(allOfficesWithInvitations,(office) => office.invitedUsers.length);
    }
    // console.log('sorting..');
    // console.log(returnList);
    if(searchedTerm.length === 0) {
      return returnList;
    }
    returnList = filter(returnList,(office) => 
      office.officeName.toLowerCase().contains(searchedTerm.toLowerCase()));
    return returnList;
  }

  render() { 
    const {allOfficesWithInvitations,sortType} = this.props;
    const {showInvitationModal,selectedOffice,users,initialInputCount,modalError,errorMessage,showInvitedAdminModal} = this.state;
    // console.log("Invite Admin state ->",this.state);
    const list = this.applySearchSort(allOfficesWithInvitations);
    return ( 
      <div>
        <div className="item-subheader">
          Please, invite people from your organization who will act as admins of their offices.
          Note, you will always be able to invite or remove admins later.
        </div>
        <div className="row mt40">
          <div className="col-md-8 col-lg-8">
            <InputGroup  style={{height:'40px'}}>
              <Input 
                className="toolkit-field" 
                placeholder="Search by office name" 
                onChange={({target}) => this.props.onSearchQueryChange(target)}/>
              <InputGroupAddon addonType="append">
                <Button className="color-DADADA border-color-C3C4C7" style={{height:'40px'}}>
                  <i style={{color:'#A5A6AC',padding:'9px 18px'}} className="flaticon-search"></i>
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </div>
          <div className="col-md-4 col-lg-4">
            <Select
              clearable={false}
              searchable={false}
              value={sortType}
              simpleValue
              options={[{value : 'a-z',label:'Name A-Z'},
              {value : 'z-a',label:'Name Z-A'},
              {value : 'invites-descending',label:'Number of admins invited (descending)'},
              {value : 'invites-ascending',label:'Number of admins invited (ascending)'}]
              }
              onChange={this.props.onSortChanged}
            />
          </div>
        </div>
        <div className="row table-responsive-sm invite-office-admins-table" 
          style={{ marginTop:'10px'}}>
          <table className="table text-primary-color tool-list-font" 
            style={{borderTop:'0px'}}>
            <thead className='bottom-border-color'>
              <tr className="font-weight-bold text-secondary">
                <th className="border-none data-mapping-table-header">
                  Office Name ({this.applySearchSort(allOfficesWithInvitations).length})
                </th>
              </tr>
            </thead>
            <tbody>
              <div style={{maxHeight:'400px',overflowY:'auto'}}>
              {
                list.length > 0 ? 
                list.map((office) => {
                  return(
                    <tr key={office.officePath}>
                      <td style={{width:'60%'}}>
                        <div>
                          {office.officeName}
                        </div>
                        <div style={{fontSize:'12px'}}>
                          {replace(office.officePath,/#/g,' > ')}
                        </div>
                      </td>
                      <td className="alert-icon-bg text-right">
                      {
                        office.isInvited ? 
                        <span className="cursor-pointer" 
                          style={{color:'#54555A'}} onClick={() => {this.toggleInvitedAdminModal(office)}}>
                          <img style={{width:'25px',marginRight:'8px'}} src={officeCreatedIcon}/>
                          Office created
                        </span> :
                        <span>(no admins invited)</span> 
                      }
                      </td>
                      <td className="color-5099DE text-right cursor-pointer" 
                        onClick={() => {this.handleInviteClick(office)}}>
                        Invite Admins
                      </td>
                    </tr>
                  )
                }) : 
                <tr>
                  <td>No Records Found.</td>
                </tr>
              }
              </div>
            </tbody>
          </table>
        </div>
        <Row className="mt40 mb10 clearfix">
          <Col sm={{ size:'6'}} style={{padding:'0'}}>
            <Col sm={{ size:'6'}}>
              <Button
                className="float-left goBackBtn w100"
                onClick={this.props.goBack}>
                <span className="cancelBtnTxt">
                  <span className="ml10 flaticon-back" /> Go Back
                </span>
              </Button>
            </Col>
          </Col>
          <Col sm={{ size:'6'}} style={{padding:'0'}}>
            <Col sm={{ size:'6', offset: 6}}>
              <Button
                className="float-right continueBtn ml10 w100"
                onClick={this.props.nextStep}>
                <span className="continueBtnTxt">
                  Continue <span className="ml10 flaticon-next" />
                </span>
              </Button>
            </Col>
          </Col>
        </Row>
        <Modal 
          isOpen={showInvitationModal || showInvitedAdminModal} 
          className="drill-down-modal">
          <ModalBody style={{padding:'30px 85px'}}>
          {
            selectedOffice && showInvitedAdminModal ? 
            <InvitedAdminModal
              invitedAdmins={selectedOffice.invitedUsers}
              selectedOffice={selectedOffice}
              toggle={this.toggleInvitedAdminModal}
              onCancelInvitation={this.props.onCancelInvitation}
            />
            : showInvitationModal ?
            <InviteAdminModal
              onInputChange={this.handleInputChange}
              onAddMember={this.handleAddMember}
              onInviteComplete={this.handleInviteComplete}
              toggle={this.toggle}
              initialInputCount={initialInputCount}
              selectedOfficeName={selectedOffice.officeName}
              modalError={modalError}
              errorMessage={errorMessage}
            /> : null
          }
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default InviteAdmin;